import { render, staticRenderFns } from "./TestApiComponent.vue?vue&type=template&id=5c8b35dc&scoped=true&"
import script from "./TestApiComponent.vue?vue&type=script&lang=js&"
export * from "./TestApiComponent.vue?vue&type=script&lang=js&"
import style0 from "./TestApiComponent.vue?vue&type=style&index=0&id=5c8b35dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8b35dc",
  null
  
)

export default component.exports